import styled from 'styled-components';

export const TextDataEmpty = styled.div`
  font-size: 16px;
  padding-top: 65px;
  display: flex;
  justify-content: center;
  width: 100%;
`;
